<template>
  <div>
    <div v-if="loginError">
      <p>{{loginError}}</p>
    </div>
    <h3>Login</h3>
    <div>
      <div class="row">
        <div class="six columns">
          <label for="login-username">Username</label>
          <input
            class="u-full-width"
            id="login-username"
            name="username"
            type="text"
            placeholder="username"
            v-model="loginUsername"
          >
        </div>
        <div class="six columns">
          <label for="login-password">Password</label>
          <input
            class="u-full-width"
            id="login-password"
            name="password"
            type="password"
            placeholder="password"
            v-model="loginPassword"
            @keyup.13="login"
          >
        </div>
        <div class="twelve columns">
          <a
            class="button"
            @click="login"
          >Login</a>
          <router-link
            class="button"
            to="/forgot"
          >Forgot Password</router-link>
        </div>
      </div>
    </div>
    <hr />
    <div>
      <p v-if="registerError">{{registerError}}</p>
    </div>
    <h3>Register</h3>
    <div v-if="!canRegister">
      You have successfully registered an account and can log in
    </div>
    <div v-if="canRegister">
      <div class="row">
        <div class="six columns">
          <label for="register-username">Username</label>
          <input
            class="u-full-width"
            id="register-username"
            type="text"
            placeholder="username"
            v-model="registerUsername"
          >
        </div>
        <div class="six columns">
          <label for="register-password">Password</label>
          <input
            class="u-full-width"
            id="register-password"
            type="password"
            placeholder="password"
            v-model="registerPassword"
          >
        </div>
      </div>
      <div class="row">
        <div class="six columns">
          <label for="register-password">Email <small>(For account recovery)</small></label>
          <input
            class="u-full-width"
            id="register-email"
            type="email"
            placeholder="email"
            v-model="registerEmail"
          >
        </div>
        <div class="six columns">
          <label for="register-password">Invitation Token</label>
          <input
            class="u-full-width"
            id="register-token"
            type="text"
            placeholder="token"
            v-model="invitationToken"
            @keyup.13="register"
          >
        </div>
      </div>
      <div class="row">
        <div class="twelve columns">
          <a
            class="button"
            type="button"
            @click="register"
          >Register</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      registerError: '',
      registerUsername: '',
      registerPassword: '',
      registerEmail: '',
      invitationToken: this.$route.query.token || '',
      canRegister: true,

      loginError: '',
      loginUsername: '',
      loginPassword: ''
    }
  },
  methods: {
    login () {
      this.$http.post(process.env.API_URL + '/login.php', {
        username: this.loginUsername,
        password: this.loginPassword
      }).then(res => {
        if (res.body.status === 'success') {
          this.loginError = ''
          this.$store.dispatch('loginUser', res.body.data).then(() => {
            this.$router.push('/')
          })
        } else {
          this.loginError = res.body.data
        }
      })
    },
    register () {
      if (!this.invitationToken) {
        this.registerError = `
          We currently require all users to provide a valid invitation token to sign up.
          You can get a invitation token from any current user. (Have them look on their "account" page.)
        `
        return
      }

      this.$http.post(process.env.API_URL + '/register.php', {
        username: this.registerUsername,
        password: this.registerPassword,
        invite_token: this.invitationToken
      }).then(res => {
        if (res.body.status === 'success') {
          this.registerError = ''
          this.loginUsername = this.registerUsername
          this.loginPassword = this.registerPassword
          this.canRegister = false
        } else {
          this.registerError = res.body.data
        }
      })
    }
  }
}
</script>

<style>
  small {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?049409df